import React, { Component } from "react";

//views
import CariAppFormViewPg1 from "../presentational/CariAppFormViewPg1";

//moment js
import moment from "moment";

import { Growl } from 'primereact/growl';

//generic functions
import {
    isEmpty,
    cloneObject,
    copyArrObject
} from "../../../../../functions/generic_functions";

//router
import {
    withRouter,
} from 'react-router-dom';

//static routes
import {
    cari_api_load_form_page_1_url,
    cari_home_pg_url,
    cari_api_university_auto_complete_url,
    cari_api_country_auto_complete_url,
    cari_api_add_applicant_new_institution_url
} from "../../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    setCariFormPageData,
    setCariFormActiveApplicationData,
    openCariModal,
    resetCariActiveData,
} from "../../../../../redux/actions/indexActions";

//redux mapper
const mapStateToProps = state => {
    return {
        activeApplicationData: state.cariReducer.activeApplicationData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setCariFormPageData: (page_data) => {
            dispatch(setCariFormPageData(page_data))
        },
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data))
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
    };
};

class CariAppFormContainerPg1 extends Component {

    state = {
        mounted: false,
        pageLoaded: false,

        submitted: false,
        page_num: 1,

        staticUiData: {
            contactPreferenceRadioOptions: [],
            legallyWorksCanadaRadioOptions: [],
            salutationDropdownOptions: [],
            workTypeDropdownOptions: [],
            degreeLevelDropdownOptions: [],
            degreeTypeDropdownOptions: [],
            degreeStatusDropdownOptions: [],
            genderDropdownOptions: [],
            isFacultyDropdownOptions: [],
        },

        postData: {
            salutation: "",
            first_name: "",
            other_name: "",
            last_name: "",
            contact_pref: "",
            phone_number: "",
            work_in_canada: "",
            citizenship_category: "",
            work_study_permit_expiry: null,
            UniversityName: "",
            customInstitutionObj: {
                institution_name: "",
                institution_country: "",
                institution_state: "",
                institution_city: "",
            },
            degree_name: "",
            degree_type: "",
            degree_level: "",
            degree_field: "",
            degree_status: "",
            start_date: null,
            end_date: null,
            current_position_title: "",
            current_position_organization: "",
            current_position_start_date: null,
            gender: "",
            is_faculty: "",
        }
    }

    constructor(props) {
        super(props);

        //refs
        this.toastRef = React.createRef();

        //load page data from api
        this.load_page_data_from_api = this.load_page_data_from_api.bind(this);

        //handlers for action
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);

        //handlers for adding new instituion
        this.handleOnChangeAddInstitution = this.handleOnChangeAddInstitution.bind(this);

        //reload page
        this.reloadPageData = this.reloadPageData.bind(this);

        //helper functions
        this.savePostDataToReduxStore = this.savePostDataToReduxStore.bind(this);
        this.getAutoCompleteParams = this.getAutoCompleteParams.bind(this);
        this.emptyDateIfInvalid = this.emptyDateIfInvalid.bind(this);
    }

    /*
        validates a date string and returns a valid date if it is not 0000-00-00 or 00-00-0000 otherwise null
    */
    emptyDateIfInvalid(dateStr) {
        if(!isEmpty(dateStr)) {
            //check if the date is not 00-00-0000 or 0000-00-00 and set date
            if(dateStr !== "00-00-0000" && dateStr !== "0000-00-00") {
                return dateStr;
            }
        }
        return null;
    }


    /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after
        }
          
        return data {
            status => true/false,
            message {
                application_status: "", //values can be: "initial", "completed", or null by default(meaning not created yet)
                postData: {
                    salutation: "",
                    first_name: "",
                    other_name: "",
                    last_name: "",
                    contact_pref: "",
                    phone_number: "",
                    work_in_canada: "",
                    citizenship_category: "",
                    work_study_permit_expiry: "",
                    UniversityName: "",
                    customInstitutionObj: {
                        institution_name: "",
                        institution_state: "",
                        institution_city: "",
                        institution_country: "",
                    },
                    degree_name: "",
                    degree_type: "",
                    degree_level: "",
                    degree_field: "",
                    degree_status: "",
                    start_date: "",
                    end_date: "",
                    current_position_title: "",
                    current_position_organization: "",
                    current_position_start_date: null,
                    gender: ""
                },
                staticUiData: {
                    salutationDropdownOptions: [],
                    workTypeDropdownOptions: [],
                    degreeLevelDropdownOptions: [],
                    degreeTypeDropdownOptions: [],
                    degreeStatusDropdownOptions: [],
                    contactPreferenceRadioOptions: [],
                    legallyWorksCanadaRadioOptions: [],
                }
            }
        }
    */
    load_page_data_from_api() {

        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        // //fetch page data from parameters
        fetch(cari_api_load_form_page_1_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {

                //successfully processed request
                if (!isEmpty(json)
                    && !isEmpty(json.status)
                    && json.status  
                    && !isEmpty(JSON.parse(json.message))
                    && !isEmpty(JSON.parse(json.message).staticUiData)
                ) {
                    var json_data = JSON.parse(json.message);

                    var fetchedPageData = json_data;

                    //set the submitted value as true/false if the string value of application status is complete data from fetched page data json
                    var fetchedSubmittedVal = false
                    var fetchedApplicationStatus = null;
                    if (!isEmpty(fetchedPageData.application_status)) {
                        fetchedApplicationStatus = fetchedPageData.application_status;
                        fetchedSubmittedVal = (fetchedPageData.application_status.toLowerCase() === "complete");
                    }
                  
                    //init local variables to detect custom institution and copy of post data and staticUiData of local state
                    var fetchedPostData = fetchedPageData.postData;
                    var fetchedStaticUiData = fetchedPageData.staticUiData;
                    var fetchedCustomInstitutionData = fetchedPageData.customInstitutionData;

                    //get deep copy of data
                    var copyStaticUiData = cloneObject(this.state.staticUiData);
                    var copyPostData = cloneObject(this.state.postData);

                    var setCustomInstitutionData = false;

                    //get post Data
                    //loop through fetched page data and set the state values if they are not null, empty string or undefined
                    for (let stateKey in copyPostData) {
                        // if (stateKey === 'customInstitutionObj') {
                        //     for (let customInstitutionKey in copyPostData[stateKey]) {
                        //         var customInstitutionObj = fetchedCustomInstitutionData[customInstitutionKey];
                        //         if (!isEmpty(customInstitutionObj)) {
                        //             copyPostData[stateKey][customInstitutionKey] = customInstitutionObj;
                        //             setCustomInstitutionData = true;
                        //         }
                        //     }
                        // }
                        //gurantees valid date
                        if (stateKey === "start_date"
                            || stateKey === "end_date"
                            || stateKey === "current_position_start_date"
                            || stateKey === "work_study_permit_expiry"
                        ) {
                            let currFetchedVal = fetchedPostData[stateKey];
                            copyPostData[stateKey] = this.emptyDateIfInvalid(currFetchedVal);
                        }
                        else {
                            let currFetchedVal = fetchedPostData[stateKey];
                            if (!isEmpty(currFetchedVal)) {
                                copyPostData[stateKey] = currFetchedVal;
                            }
                        }

                        //set custom institution checkbox to true
                        if (setCustomInstitutionData) {
                            copyPostData.customInstitutionCheckboxVal = true;
                        }
                    }

                    //get static Ui Data
                    //loop through fetched page data and set the state values if they are not null, empty string or undefined
                    for (let stateKey in copyStaticUiData) {
                        let currFetchedVal = fetchedStaticUiData[stateKey];
                        if (!isEmpty(currFetchedVal)) {
                            copyStaticUiData[stateKey] = currFetchedVal;
                        }
                    }

                    //set page loaded to true
                    this.setState({
                        pageLoaded: true,
                        postData: copyPostData,
                        staticUiData: copyStaticUiData,
                        submitted: fetchedSubmittedVal,
                    }, () => {
                        //get copy of post data and save to redux store
                        var reduxCopyPostData = cloneObject(this.state.postData);
                        this.savePostDataToReduxStore(reduxCopyPostData);

                        //save application status to store
                        var updatedApplicationData = this.props.activeApplicationData;
                        updatedApplicationData.application_status = fetchedApplicationStatus;
                        this.props.setCariFormActiveApplicationData(updatedApplicationData);
                    });
                }
                //if api returns no data, popup modal 
                else {
                    // this.props.openCariModal({
                    //     modalId: "errorModal",
                    //     title: "Failed to retrieve data. ",
                    //     callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                    // });
                }
            })
            //if api is not found
            .catch((error) => {
                console.log(error);

                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Something went wrong.",
                    callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                });
            });
    }

    savePostDataToReduxStore(reduxCopyPostData) {
        //set page num for redux post data
        reduxCopyPostData['page_num'] = this.state.page_num;
        this.props.setCariFormPageData(reduxCopyPostData);
    }


    componentDidMount() {
        this.setState({
            mounted: true
        }, () => {
            this.load_page_data_from_api();
        })
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    reloadPageData(fetchedPageData, callBackFunc) {
        //set the submitted value as true/false if the string value of application status is complete data from fetched page data json
        var fetchedSubmittedVal = false;
        var fetchedApplicationStatus = null;
        if (!isEmpty(fetchedPageData.application_status)) {
            fetchedApplicationStatus = fetchedPageData.application_status;
            fetchedSubmittedVal = (fetchedPageData.application_status.toLowerCase() === "complete");
        }
      
        //init local variables to detect custom institution and copy of post data and staticUiData of local state
        var fetchedPostData = fetchedPageData.postData;
        var fetchedStaticUiData = fetchedPageData.staticUiData;
        var fetchedCustomInstitutionData = fetchedPageData.customInstitutionData;

        //get deep copy of data
        var copyStaticUiData = cloneObject(this.state.staticUiData);
        var copyPostData = cloneObject(this.state.postData);
      
        var setCustomInstitutionData = false;

        //get post Data
        //loop through fetched page data and set the state values if they are not null, empty string or undefined
        for (let stateKey in copyPostData) {
            // if (stateKey === 'customInstitutionObj') {
            //     for (let customInstitutionKey in copyPostData[stateKey]) {
            //         var customInstitutionObj = fetchedCustomInstitutionData[customInstitutionKey];
            //         if (!isEmpty(customInstitutionObj)) {
            //             copyPostData[stateKey][customInstitutionKey] = customInstitutionObj;
            //             setCustomInstitutionData = true;
            //         }
            //     }
            // }
            //gurantees valid date
            if (stateKey === "start_date"
                || stateKey === "end_date"
                || stateKey === "current_position_start_date"
                || stateKey === "work_study_permit_expiry"
            ) {
                let currFetchedVal = fetchedPostData[stateKey];
                copyPostData[stateKey] = this.emptyDateIfInvalid(currFetchedVal);
            }
            else {
                let currFetchedVal = fetchedPostData[stateKey];
                if (!isEmpty(currFetchedVal)) {
                    copyPostData[stateKey] = currFetchedVal;
                }
            }

            //set custom institution checkbox to true
            if (setCustomInstitutionData) {
                copyPostData.customInstitutionCheckboxVal = true;
            }
        }

        //get static Ui Data
        //loop through fetched page data and set the state values if they are not null, empty string or undefined
        for (let stateKey in copyStaticUiData) {
            let currFetchedVal = fetchedStaticUiData[stateKey];
            if (!isEmpty(currFetchedVal)) {
                copyStaticUiData[stateKey] = currFetchedVal;
            }
        }

        //set page loaded to true
        this.setState({
            pageLoaded: true,
            postData: copyPostData,
            staticUiData: copyStaticUiData,
            submitted: fetchedSubmittedVal,
        }, () => {

            //get copy of post data and save to redux store
            var reduxCopyPostData = cloneObject(this.state.postData);
            this.savePostDataToReduxStore(reduxCopyPostData);

            //save application status to store
            var updatedApplicationData = this.props.activeApplicationData;
            updatedApplicationData.application_status = fetchedApplicationStatus;
            this.props.setCariFormActiveApplicationData(updatedApplicationData);

            //call back function if not null
            if (!isEmpty(callBackFunc)) {
                callBackFunc();
            }
        });
    }

    //handles on change events for setting states for form input for post data
    handleOnChangeSetParentState(value, nameKey) {
        var copyPostData = cloneObject(this.state.postData);

        //if namekey is work in canada, citizenship category
        if (nameKey === "work_in_canada"
            || nameKey === "citizenship_category"
        ) {
            //set itself
            copyPostData[nameKey] = value;
            //if no for working in canada reset all data below
            if (nameKey === "work_in_canada" && value.toLowerCase() === "no") {
                copyPostData.citizenship_category = "";
                copyPostData.work_study_permit_expiry = null;
            }
            //if citizenship_category and value is empty, OR value is permanent resident or canadian citizen, reset the work study permit expiry date
            else if (nameKey === "citizenship_category") {
                if (isEmpty(value) 
                    || value.toLowerCase() === "permanent resident"
                    || value.toLowerCase() === "canadian citizen"
                ) {
                    copyPostData.work_study_permit_expiry = null;
                }
            }
        }
        //if the namekey is start_date
        else if (nameKey === "start_date") {

            //if the end date currently is before start date, blank out start date
            if (moment(this.state.postData.end_date).isBefore(value)) {

                //blank out the value
                copyPostData[nameKey] = null;

                //display toast
                this.toastRef.current.show({life: 40000, severity: 'error', summary: 'Invalid Date', detail: "Your Highest Degree Completion or Expected Completion Date is before the Start Date. You will need to re-enter your Start Date" });
            }
            else {
                //set itself
                copyPostData[nameKey] = value;
            }
        }
        //if the namekey is end date
        else if (nameKey === "end_date") {
            //set itself
            copyPostData[nameKey] = value;
        }

        // //if the namekey is institution_modal, popup the modal
        // else if(nameKey === "institution_modal") {
        //     //popup a modal, ok click, set checkbox, else do nothing
        //     this.props.openCariModal({
        //         modalId: "addInstitutionModal",
        //         title: "Add Institution",
        //         contentText: "Please complete the following fields to add an institution.",
        //         callBackFuncOnOk: (data) => {
        //             copyPostData['UniversityName'] = data['institution_name'];
        //             copyPostData.customInstitutionObj['institution_name'] = data['institution_name'];
        //             copyPostData.customInstitutionObj['institution_country'] = data['institution_country'];
        //             copyPostData.customInstitutionObj['institution_state'] = data['institution_state'];
        //             copyPostData.customInstitutionObj['institution_city'] = data['institution_city'];

        //             //set data
        //             this.setState({
        //                 postData: copyPostData,
        //             }, () => {
        //                 //get copy of post data and save to redux store
        //                 this.savePostDataToReduxStore(this.state.postData);
        //                 return;
        //             });
        //         }
        //     });
        // }
        //postdata nameKeys set
        else {
            //set the value at nameKey
            copyPostData[nameKey] = value;
        } 

        //set data
        this.setState({
            postData: copyPostData,
        });

        //get copy of post data and save to redux store
        var reduxCopyPostData = cloneObject(copyPostData);
        this.savePostDataToReduxStore(reduxCopyPostData);
    }

    handleOnChangeAddInstitution(newInstitutionData, callBackFunc) {

        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;
        var newInstitutionObj = newInstitutionData;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);
        form_data.append("newInstitutionObj", JSON.stringify(newInstitutionObj));

        fetch(cari_api_add_applicant_new_institution_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            var responseHttpCode = response.status;
            //good request
            if (responseHttpCode === 200) {
                return response.json();
            }
            //404 api not found, allows user to retry
            else if (responseHttpCode === 404) {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Bad Request, please try again.",
                });
            }
            //invalid data and not authorized, reset cari data
            else {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "User Session is invalid or has expired, please login again.",
                    callBackFuncOnOk: () => {
                        this.props.resetCariActiveData();
                    }
                });
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message))
                && JSON.parse(json.message).institutionAdded
            ) {
                var json_data = JSON.parse(json.message);
                
                //call back to reload page and display toast
                this.reloadPageData(json_data, () => {
                    this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Successfully saved the new institution!', detail: "" });
                });
            
            }
            //if api returns no data
            else {
                this.toastRef.current.show({ life: 6000, severity: 'danger', summary: 'Failed to save the new institution!', detail: "" });
            }
        })
        //if api is not found
        .catch((error) => {
            this.toastRef.current.show({ life: 6000, severity: 'danger', summary: 'Failed to save the new institution!', detail: "" });
        });

    }

    /*
        returns the email, token and application id from redux store
    */
    getAutoCompleteParams() {
        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        var autoCompleteParams = {
            email: currentEmail,
            token: currentToken,
            application_id: currentApplicationId
        }
        return autoCompleteParams;
    }

    render() {
        const autoCompleteUrls = {
            "cari_api_university_auto_complete_url": cari_api_university_auto_complete_url,
            "cari_api_country_auto_complete_url": cari_api_country_auto_complete_url
        }
        const today = moment().format("YYYY-MM-DD");

        return (
            <div>
                <Growl
                    ref={this.toastRef}
                    baseZIndex={9000}
                    position={"topright"}
                />
                <CariAppFormViewPg1
                    pageLoaded={this.state.pageLoaded}
                    customInstitutionCheckboxVal={this.state.customInstitutionCheckboxVal}
                    staticUiData={this.state.staticUiData}
                    postData={this.state.postData}
                    onChangeSetParentState={this.handleOnChangeSetParentState}
                    onAddInstitution={this.handleOnChangeAddInstitution}
                    submitted={this.state.submitted}
                    autoCompleteUrls={autoCompleteUrls}
                    autoCompleteParams={this.getAutoCompleteParams()}
                    today={today}
                />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormContainerPg1));